const BASE = "https://waginstitute.org";
const P = "/product-details/product/";

export const wagiUrl = (medium, path = "") =>
  `${BASE}${path}${path.includes("?") ? "&" : "?"}utm_source=wordalivetx&utm_medium=${medium}`;

export const WAGI_PATHS = {
  courses: "/products-list",
  year1: `${P}65a98f5135c41d722eb50987`,
  year2: `${P}65b85157d4112a3a63c63917`,
  shortCourses: "/products-list/collections/mini-courses",
  teachers: "/our-teachers",
};

const BOOK_COURSES = [
  { test: /war for your bloodline|guerra por tu linaje/i, label: "War for Your Bloodline", path: `${P}65a98e43a0fb69c7208556c7` },
  { test: /^the anointing\b/i, label: "The Anointing", path: `${P}660591f8b2bb1e630db0fe6a` },
  { test: /\bsonship\b/i, label: "Sonship", path: `${P}67eda1d5070f763cc03c9dde` },
  { test: /prophetic intercession/i, label: "Prophetic Intercession", path: `${P}67ed9ff9aa5f15348eac56e2` },
  { test: /kingdom authority/i, label: "Understanding Kingdom Authority", path: `${P}67eda38776ac3c0d5327ab73` },
  { test: /what is a shofar|mysteries of the shofar/i, label: "Unlocking the Mysteries of the Shofar", path: `${P}663110cd8f2326f39d78a5f6` },
];

export function wagiCourseFor(productName = "") {
  if (/\d+\s?ml/i.test(productName)) return null;
  const hit = BOOK_COURSES.find((c) => c.test.test(productName));
  return hit ? { label: hit.label, url: wagiUrl("bookstore", hit.path) } : null;
}

export const WAGI_ENROLL_LINE = "Open Enrollment · Self-Paced Online Courses";

const FEATURED_COURSES = [
  { title: "War for Your Bloodline", price: "$250", path: `${P}65a98e43a0fb69c7208556c7` },
  { title: "School of Apostles & Prophets", price: "$250", path: `${P}67eda51b070f7606823d15c7` },
  { title: "The Anointing", price: "$125", path: `${P}660591f8b2bb1e630db0fe6a` },
  { title: "Sonship", price: "$125", path: `${P}67eda1d5070f763cc03c9dde` },
  { title: "Prophetic Intercession", price: "$125", path: `${P}67ed9ff9aa5f15348eac56e2` },
  { title: "Understanding Kingdom Authority", price: "$125", path: `${P}67eda38776ac3c0d5327ab73` },
  { title: "Unlocking the Mysteries of the Shofar", price: "$50", path: `${P}663110cd8f2326f39d78a5f6` },
];

export function getFeaturedCourse(now = Date.now()) {
  const week = Math.floor(now / (7 * 24 * 60 * 60 * 1000));
  return FEATURED_COURSES[week % FEATURED_COURSES.length];
}
